module.exports = __webpack_public_path__ + "static/media/recycled_paper.4f4842e0.jpg";